/** Formatting helpers for the Context stats line (plan §A.1). */

export function formatTokens(n: number): string {
  return n.toLocaleString("en-US");
}

export function formatCost(micros: number): string {
  return `$${(micros / 1_000_000).toFixed(2)}`;
}
